<nz-result nzStatus="404" nzTitle="404">
  <div nz-result-extra>
    <a routerLink="/">
      <!-- <button nz-button nzType="primary">Back Home</button> -->
    </a>
  </div>
</nz-result>
